export enum ServiceRequestsEnum {
    REPAIR = 'REPAIR',
    MAINTENANCE = 'MAINTENANCE',
    SERVICE = 'SERVICE'
}